var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "a-modal",
    {
      staticClass: "modal-content",
      attrs: {
        title: _vm.title || _vm.form.id ? "编辑" : "创建",
        width: 870,
        visible: _vm.visible,
        destroyOnClose: "",
        "ok-text": "保存",
      },
      on: { ok: _vm.handleOk, cancel: _vm.hideModal },
    },
    [
      [
        _c(
          "a-form-model",
          {
            ref: "ruleForm",
            attrs: {
              labelCol: { span: 3 },
              wrapperCol: { span: 20 },
              model: _vm.form,
              rules: _vm.rules,
            },
          },
          [
            _c(
              "a-form-model-item",
              { attrs: { label: "标题", prop: "title" } },
              [
                _c("a-input", {
                  attrs: { placeholder: "请输入标题" },
                  model: {
                    value: _vm.form.title,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "title", $$v)
                    },
                    expression: "form.title",
                  },
                }),
              ],
              1
            ),
            _c(
              "a-form-model-item",
              { attrs: { label: "上传封面", prop: "coverUrl" } },
              [
                _c(
                  "div",
                  { staticClass: "flex-align-center" },
                  [
                    _c("j-image-upload", {
                      ref: "coverRef",
                      attrs: {
                        accept: ".png,.jpg,.jpeg",
                        otherData: { compress: 1 },
                        bizPath: "dayOath",
                      },
                      on: { change: _vm.imgChange },
                      model: {
                        value: _vm.form.coverUrl,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "coverUrl", $$v)
                        },
                        expression: "form.coverUrl",
                      },
                    }),
                  ],
                  1
                ),
              ]
            ),
            _c(
              "a-form-model-item",
              { attrs: { label: "高考结束日期", prop: "endDate" } },
              [
                _c("a-date-picker", {
                  staticStyle: { width: "100%" },
                  model: {
                    value: _vm.form.endDate,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "endDate", $$v)
                    },
                    expression: "form.endDate",
                  },
                }),
              ],
              1
            ),
            _c(
              "a-form-model-item",
              { attrs: { label: "权益", prop: "memberId" } },
              [
                _c("a-select", {
                  attrs: {
                    mode: "multiple",
                    options: _vm.memberOptions,
                    placeholder: "请选择权益",
                  },
                  model: {
                    value: _vm.form.memberId,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "memberId", $$v)
                    },
                    expression: "form.memberId",
                  },
                }),
              ],
              1
            ),
            _c(
              "a-form-model-item",
              { attrs: { label: "简介", prop: "courseDesc" } },
              [
                _c("a-textarea", {
                  attrs: {
                    placeholder: "请输入简介",
                    "auto-size": { minRows: 3, maxRows: 5 },
                  },
                  model: {
                    value: _vm.form.intro,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "intro", $$v)
                    },
                    expression: "form.intro",
                  },
                }),
              ],
              1
            ),
          ],
          1
        ),
      ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }